import { createContext, useContext } from 'react';
import type { FilterContextType } from './FilterProvider';

export const FilterContext = createContext<FilterContextType | undefined>(undefined);

const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilterContext must be used within a FilterProvider');
  }
  return context;
};

export default useFilterContext;
